import {
  Avatar,
  Box,
  Button,
  Chip,
  Grid,
  ListItemAvatar,
  ListItemText,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { TransactionI } from 'src/api/manageProductsApi/types'

type ViewSaleReportsDetailsModalProps = {
  transaction: TransactionI
  open: boolean
  onClose: () => void
}
const ViewSaleReportsDetailsModal = ({
  transaction,
  open,
  onClose,
}: ViewSaleReportsDetailsModalProps) => {
  return (
    <Box>
      <SimpleModal open={!!(open && transaction)} onClose={onClose}>
        {!!transaction && (
          <Box>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Order ID:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {transaction?.id} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Status:</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {transaction.status} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Shipping Address: :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {transaction.shipping_address} </Typography>
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={3}>
                <Typography variant='h4'>Amount Payable :</Typography>
              </Grid>
              <Grid xs={9}>
                <Typography variant='h5'> {transaction.amount_payable} </Typography>
              </Grid>
            </Grid>

            <Grid container mt={3}>
              <Grid item xs={12}>
                <Typography variant='h4'>Order Items:</Typography>
              </Grid>
              {transaction.order_items?.map((orderItem) => (
                <Grid container item key={orderItem.id} mt={2} spacing={2}>
                  <Grid item xs={3}>
                    <ListItemAvatar>
                      <Avatar
                        alt={orderItem.item.title}
                        src={orderItem.item.picture}
                        style={{ height: '100px', width: '100px' }}
                      />
                    </ListItemAvatar>
                  </Grid>
                  <Grid item xs={9}>
                    <ListItemText style={{ color: 'white' }}>
                      <Typography>Name: {orderItem.item.title}</Typography>
                      <Typography>Description: {orderItem.item.description}</Typography>
                      <Typography>Quantity: {orderItem.quantity}</Typography>
                      <Typography>
                        Price: {orderItem.item.price} {orderItem.item.unit}
                      </Typography>
                    </ListItemText>
                  </Grid>
                </Grid>
              ))}
            </Grid>
          </Box>
        )}
      </SimpleModal>
    </Box>
  )
}

export default ViewSaleReportsDetailsModal
